import { Injectable } from "@angular/core";
import { EnderecoModel } from "../models/endereco.model";
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: "root"
})
export class UtilService {
  
  constructor(private http: HttpClient) {
  }


  separarDDDTelefone(telefoneCompleto: string, removerTraco: boolean = true): string[]{

    telefoneCompleto = telefoneCompleto.replace(/ /g, "");

    if(removerTraco){
      telefoneCompleto = telefoneCompleto.replace("-", "");
    }

    return telefoneCompleto.replace('(', "").split(")");
  }


  flattenObject(obj){
    const flattened = {}
  
    Object.keys(obj).forEach((key) => {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        Object.assign(flattened, this.flattenObject(obj[key]))
      } else {
        flattened[key] = obj[key]
      }
    })
  
    return flattened
  }

 verifyCpf(cpf: string): boolean {
    cpf = cpf.replace(/[^\d]+/g, '');
    if (!cpf || cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
      return false;
    }
    let soma = 0;
    for (let i = 0; i < 9; i++) {
      soma += parseInt(cpf.charAt(i)) * (10 - i);
    }

    let resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;
    soma = 0;
    for (let i = 0; i < 10; i++) {
      soma += parseInt(cpf.charAt(i)) * (11 - i);
    }
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(10))) return false;

    return true;
  }

  buscaCep(cep: string): Observable<EnderecoModel> {
    cep = cep.replace(/[^\d]+/g, '');
    const cepUrl = `https://viacep.com.br/ws/${cep}/json/`;
    
    return this.http.get<any>(cepUrl).pipe(
        map(dados => {
          if (String(dados.erro) === 'true') {
            throw new Error('CEP não encontrado');
          }

          return dados as EnderecoModel;
        })
      );
  }

public salvarArquivo(dados: Blob, nomeArquivo: string): void {
  const url = window.URL.createObjectURL(dados);
  const a = document.createElement('a');
  a.href = url;
  a.download = nomeArquivo;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
}
}